import { Bar } from 'react-chartjs-2'
import { colorPalette } from '../../utils/color-utils'

export default function ChartExtendMonth({ record, filtered, title, labelRecord, labelFilter }: any) {
    const labels = record.map((item: any) => item.month)

    const datasets = [
        {
            type: 'line',
            label: labelFilter,
            data: filtered.map((item: any) => item.sum),
            borderWidth: 2,
            datalabels: {
                color: colorPalette[4],
            },
            hidden: true,
        },
        {
            type: 'bar',
            label: labelRecord,
            data: record.map((item: any) => item.sum),
            borderWidth: 2,
            datalabels: {
                color: colorPalette[6],
            },
        },
    ] as any

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                color: 'black',
                font: {
                    size: 14,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Bar data={{ labels, datasets }} options={options} />
    )
}
